const check = require('check-types');
const {
  runModifiers
} = require('./utils');
module.exports = function () {
  let values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return check.object(modifiers) && check.object(values) ? Object.entries(values).reduce((acc, _ref) => {
    let [key, value] = _ref;
    return Object.assign(acc, {
      [key]: runModifiers(modifiers[key], value, values)
    });
  }, {}) : values;
};